import { Component, ViewEncapsulation, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { ChipModule } from 'primeng/chip';
import { IconFieldModule } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { ButtonModule } from 'primeng/button';
import { Table, TableLazyLoadEvent, TableModule } from 'primeng/table';
import { HeadingComponent } from '../../../../../shared/components/heading/heading.component';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchReviewerQueryParams, SearchReviewerResponse, Reviewer, UpdateUserStatus } from '../people.interface';
import { PeopleService } from '../../../../../shared/services/people.service';
import { ProjectService } from '../../../../../shared/services/project.service';
import { ConfigurationService } from '../../../../../shared/services/configuration.service';
import { constants } from '../../../../../shared/constants/constants';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmationDialogService } from '../../../../../shared/services/confirmation-dialog.service';
import { ToastService } from '../../../../../shared/services/toast.service';
import { UserService } from '../../../../../shared/services/user.service';
import { DeleteUserByFirm, UserClientVm } from '../../../../../store/user/user.interface';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DeleteUserConfirmation } from './modals/delete/delete-user-confirmation.component'
import { ReviewerDetailDialogService } from '../../../../../shared/services/reviewer-detail-dialog.service';
import { RatingModule } from 'primeng/rating';
import { TooltipModule } from 'primeng/tooltip';
import { EmittersService } from '../../../../../shared/services/emitters.service';
import { Subscription } from 'rxjs';
import { TagModule } from 'primeng/tag';
import { DialogModule } from 'primeng/dialog';
import moment from 'moment'; 
import { StorageService } from '../../../../../shared/services/storage.service';
import { PipesModule } from '../../../../../shared/pipes/pipes.module';
import { HelperService } from '../../../../../shared/services/helper.service';

@Component({
  selector: 'app-all',
  standalone: true,
  imports: [DropdownModule, ButtonModule, FormsModule, RatingModule, ChipModule, IconFieldModule, InputIconModule, InputSwitchModule, HeadingComponent, InputTextModule, TableModule, CommonModule, TooltipModule, TagModule, DialogModule, PipesModule],
  templateUrl: './all.component.html',
  styleUrl: './all.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AllComponent implements OnInit, OnDestroy {
  headingButton = {
    url: '/client/people/invite-candidate',
    label: 'INVITE CANDIDATE',
    icon: 'x',
    colorClass: 'button-bg-pink'
  }
  pendingCandidateButton = {
    url: '/client/people/pending-candidates',
    label: 'PENDING CANDIDATES',
    icon: 'x'
  }
  expiredCredentialsCandidateButton = {
    url: '/client/people/expired-credential-candidates',
    label: 'EXPIRED CREDENTIALS',
    icon: 'x'
  }
  sortings: any = [];
  userFilters: any = [];
  selectedSortOrder = {
    name: '',
    value: ''
  };
  reviewerCount: number = 0;
  searchMarkets: any = [];
  reviewers: Reviewer[] = [];
  selectedUserFilter = {
    name: '',
    value: ''
  };
  searchText = '';
  displaySearchTextChip = false;
  searchTextDisplaying = '';
  ref: DynamicDialogRef | undefined;
  @ViewChild('reviewerTable') reviewerTable: Table | undefined;
  reviewerListEmitterSubscription: Subscription | undefined;
  searchMarketsSelecterEmitter: Subscription | undefined;
  openUnarchiveModal = false;
  selectedReviewer: any = null;
  userObject: any;
  isPwcEnabled = false;
  totalRecords: number = 0;
  /**
   * Cooldown for the manual "Resend Invite" button. Mirrors
   * constants.invite.RESEND_COOLDOWN_DAYS on the backend, which enforces the same rule —
   * keep the two in step.
   */
  readonly RESEND_INVITE_COOLDOWN_DAYS = 7;

  constructor(private route: ActivatedRoute, private peopleService: PeopleService, private configurationService: ConfigurationService,
    private confirmationDialogService: ConfirmationDialogService, private toast: ToastService, private userService: UserService,
    public dialogService: DialogService, private projectService:ProjectService,private reviewerDetailDialogService:ReviewerDetailDialogService,
    private router:Router, private emitterService: EmittersService, private storageService:StorageService, public helperService: HelperService
  ) {
  }

  ngOnInit() {
    this.userObject = this.userService.getSessionUser();
    this.isPwcEnabled = this.configurationService.getPwcFlag();
    this.sortings = constants.sortingFilter;
    this.userFilters = [
      { name: 'All', value: 'all'},
      { name: 'Currently working', value: 'currentlyWorking' },
      { name: 'Active', value: 'active' },
      { name: 'Inactive', value: 'inactive' },
      { name: 'Invited', value: 'invited' },
      { name: 'Archive', value: 'archive' },
    ];
    this.selectedUserFilter = this.userFilters.find((userFilter: any) => userFilter.value === 'all');
    this.subscribeEvent();
    this.getPendingReviewers();
  }

  subscribeEvent(): void{
    this.reviewerListEmitterSubscription = this.emitterService.reviewerListEmitter.subscribe(() => {
      this.reloadReviewerTable();
    })
    this.searchMarketsSelecterEmitter = this.emitterService.searchMarketSelectorEmitter.subscribe(()=>{
      this.reloadReviewerTable();
    });
  }

  ngOnDestroy(): void {
    this.reviewerListEmitterSubscription && this.reviewerListEmitterSubscription.unsubscribe();
    this.searchMarketsSelecterEmitter && this.searchMarketsSelecterEmitter.unsubscribe();
  }

  reloadReviewerTable(){
    if (this.reviewerTable) {
      const event: TableLazyLoadEvent = {
        first: this.totalRecords,
        rows: this.reviewerTable.rows
      };
      this.getReviewers(event);
    }
  }

  activateUser($event: Event, reviewer: any) {
    const mesg = `Are you sure you want to activate ${reviewer.firstName} ${reviewer.lastName} ? This will count against your total allotment of active users.`
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message: mesg,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        const data: UpdateUserStatus = {
          userId: reviewer._id,
          status: !reviewer.status
        }
        this.peopleService.updateUserStatusByFirm(data).subscribe({
          next: (resp) => {
            reviewer.status = resp.status;
            this.toast.showSuccess('User activated successfully');
          },
          error: (error) => {
            reviewer.status = !reviewer.status;
            console.error('Error occurred:', error);
          }
        });
      },
    });
  }

  resendInvite($event: Event, reviewer: any){
    const mesg = `You are about to resend an email invitation to ${reviewer.firstName } ${ reviewer.lastName }.`
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message: mesg,
      header: `Resend Invite to ${reviewer.firstName } ${ reviewer.lastName }`,
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      acceptLabel: "Send Invite",
      rejectIcon: "none",
      rejectLabel: "Cancel",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        this.peopleService.resendCandidateInvite(reviewer._id).subscribe({
          next: (resp) => {
            this.toast.showSuccess('User invite sent successfully');
            reviewer.cannotReInvite = true;
            this.getReviewers({ first: 0, rows: 10 });
          }
        });
      },
    });
  }
  onSortChange(event: any) {
    this.selectedSortOrder = event.value;
    this.getReviewers({ first: 0, rows: 10 });
  }
  onFilterChange(event: any) {
    this.selectedUserFilter = event.value;
    this.getReviewers({ first: 0, rows: 10 });
  }
  getSearchMarkets() {
    let selectedMarkets = this.storageService.getSelectedSearchMarkets();
    if(selectedMarkets && selectedMarkets.length > 0){
      return selectedMarkets.join(',');
    }
    return [];
  }
  onEnter($event: any) {
    if ($event.keyCode === 13) {
      this.onSearchClick();
    }
  }
  onSearchClick() {
      this.getReviewers({ first: 0, rows: 10 });
      this.searchTextDisplaying = this.searchText.slice(0);
      this.displaySearchTextChip = this.searchText === '' ? false : true;
  }

  isAdminApprovalPending(reviewer: Reviewer): boolean{
    const currentTenant = this.getCurrentTenant(reviewer);
    return currentTenant.reviewerStatus && currentTenant.reviewerStatus === constants.userVerificationStatus.pendingAdminVerification;
  }

  isArchivedByReviewer(reviewer: Reviewer): boolean{
    const currentTenant = this.getCurrentTenant(reviewer);
    return currentTenant.deletedBy && currentTenant.deletedBy.role && currentTenant.deletedBy.role === constants.userRoles.reviewer;
  }

  onRemoveChip(type: string) {
    if (type === 'sortOrder') {
      this.selectedSortOrder = {
        name: '',
        value: ''
      };
    } else if (type === 'userFilter') {
      this.selectedUserFilter = {
        name: '',
        value: ''
      };
    } else {
      this.searchText = '';
      this.searchTextDisplaying = '';
      this.displaySearchTextChip = false;
    }
    this.getReviewers({ first: 0, rows: 10 });
  }
  getReviewers(event?: any) {
    if(!event.sortField){
      const offset = event.first;
      const limit = event.rows;
      const queryParams: SearchReviewerQueryParams = {
        sortOrder: constants.sortingOrder.descending,
        offset: offset,
        limit: limit,
        markets: this.getSearchMarkets(),
        searchOn: 'all',
        userStatus: 'all'
      };
  
      if (this.selectedSortOrder.value) {
        queryParams.sortBy = this.selectedSortOrder.value;
        if(queryParams.sortBy === 'firstName'){
          queryParams.sortOrder = constants.sortingOrder.ascending;
        }
      }
  
      if (this.selectedUserFilter.value) {
        queryParams.userStatus = this.selectedUserFilter.value;
      }
      if (this.searchText) {
        queryParams.search = this.searchText;
      }
      this.peopleService.searchReviewers(queryParams).subscribe((response: SearchReviewerResponse) => {
        this.reviewers = response.users.map((user: Reviewer) => {
          const tenant: any = this.getCurrentTenant(user) || {};
          return {
            ...user,
            status: tenant.isActive,
            defaultTenantRating: tenant.defaultRatings,
            cannotReInvite: this.resendInviteNotAllowed(user) 
          }
        });
        this.reviewerCount = response.count;
        this.filterData();
      })
    }else{
        this.sortData(event.sortField, event.sortOrder);
    }
    
  }

  /**
   * MP-5638/MP-5636: match the reviewer's tenant entry on the family ROOT.
   *
   * A reviewer holds one entry per family, keyed to the root, while the
   * acting firm may be a CHILD. Comparing against the acting firm id found
   * nothing for a child-firm user, and the caller then read `.isActive` off
   * undefined - so the whole `.map()` threw and the table rendered EMPTY from
   * a correct API response. For a root or standalone firm the root is the
   * firm itself, so nothing changes.
   */
  getCurrentTenant(reviewer:Reviewer){
    const rootFirmId = this.userService.getFamilyRootFirmId();

    return reviewer.tenants.find((tenant:any) => 
      tenant.firm && !tenant.firm?.id && tenant.firm == rootFirmId ||
      tenant.firm?.id === rootFirmId
    );
  }


  resendInviteNotAllowed(reviewer:any){
    const tenant = this.getCurrentTenant(reviewer);

    // No tenancy for the current firm: nothing to resend against.
    if (!tenant) return true;

    // Never sent: allow the first manual invite.
    if (!tenant.lastInviteSentAt) return false;

    return moment().diff(moment(tenant.lastInviteSentAt), 'days') < this.RESEND_INVITE_COOLDOWN_DAYS;
  }
  

  sortData(field: 'fullName' | 'email' | 'averageRating',sortOrder:number){
    if(field){
      this.reviewers.sort((a, b) => {
        let valueA = a[field] ?? ''; // Optional chaining and nullish coalescing
        let valueB = b[field] ?? ''; // Optional chaining and nullish coalescing

  
        let comparison = 0;
        if (valueA > valueB) {
          comparison = 1;
        } else if (valueA < valueB) {
          comparison = -1;
        }
        return sortOrder === -1 ? comparison * -1 : comparison;
      });
    }
   
  }
  filterData(){
    this.reviewers.map((resp:Reviewer)=>{
      resp.fullName = `${resp.firstName} ${resp.lastName}`;
    })
  }

  moveToRestrictedList($event: Event, reviewer: Reviewer) {
    const [action, preposition] = reviewer.isRestricted ? ['remove', 'from'] : ['add', 'to'];

    const mesg = `You are about to ${action} ${reviewer.firstName} ${reviewer.lastName} ${preposition} your Restricted list. Are you sure?`;
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message: mesg,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        if(!reviewer.isRestricted){
          this.peopleService.moveToRestrictedList(reviewer._id).subscribe((response: any) => {
            this.getReviewers({ first: 0, rows: 10 });
            this.toast.showSuccess('Moved to Restricted list');
          });
        }else{
          this.peopleService.removeFromRestrictedList(reviewer._id).subscribe((response: any) => {
            this.getReviewers({ first: 0, rows: 10 });
            this.toast.showSuccess('Removed from restricted list')
          })
        }
      }
    });

  }
  moveToWorkedTogetherList($event: Event, reviewer: Reviewer) {
    const [action, preposition] = reviewer.workedTogether ? ['remove', 'from'] : ['add', 'to'];
    const mesg = `You are about to ${action} ${reviewer.firstName} ${reviewer.lastName} ${preposition} your Worked Together list. Are you sure?`;
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message: mesg,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        if(reviewer.workedTogether){
          this.peopleService.removeFromWorkedTogetherList(reviewer._id).subscribe((resp: any) => {
            this.toast.showSuccess('Removed from Worked Together list');
            reviewer.workedTogether = false;
          })
        }else {
          this.peopleService.moveToWorkedTogetherList(reviewer._id).subscribe((response: any) => {
            this.toast.showSuccess('Moved to Worked Together list');
            reviewer.workedTogether = true;
          })
        }
      }
    });

  }
  approveReviewer($event: Event, reviewer: Reviewer) {
    const mesg = `You are about to approve ${reviewer.firstName} ${reviewer.lastName}. Are you sure?`
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message: mesg,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        this.userService.approveUser(reviewer._id).subscribe((response: any) => {
          this.getReviewers({ first: 0, rows: 10 });
          this.toast.showSuccess('Reviewer Approve Successfully')
        })
      }
    });
  }
  fireAndQuit($event: Event, reviewer: Reviewer) {
    const data = {
      heading: `You are about to fire ${reviewer.firstName} ${reviewer.lastName}`,
      from: 'fireAndQuit',
      textAreaHeading: 'Reason'
    }
    $event.stopPropagation();
      this.ref = this.dialogService.open(DeleteUserConfirmation, {
          data: data,
          header: 'Confirmation',
          width: '30vw',
          contentStyle: { overflow: 'auto' },
          breakpoints: {
              '960px': '75vw',
              '640px': '90vw'
          }
      });
      this.ref.onClose.subscribe((data: DeleteUserByFirm) => {
          if (data) {
             this.projectService.fireReviewerFromProject(reviewer._id, reviewer.positionId ? reviewer.positionId : '',data.reason,reviewer.isDRSSubmitted).subscribe((response: any) => {
              this.getReviewers({ first: 0, rows: 10 });
              this.toast.showSuccess('User Fire Successfully')
            }) 
          }
          
      });
  }
 
  showDeleteReviewerConfirmation($event:Event,reviewer:Reviewer) {
    const isArchive = this.selectedUserFilter && this.selectedUserFilter.value === 'archive';
    if(isArchive){
      this.selectedReviewer = reviewer;
      this.openUnarchiveModal = true;
      return;
    }
    const data = {
      heading: `Are you sure you want to ${!isArchive ? 'archive' : 'unarchive'} ${reviewer.firstName} ${reviewer.lastName}?`,
      from: 'deleteReviewer',
      textAreaHeading: 'Comment',
      isCommentOptional: true
    }
    $event.stopPropagation();
      this.ref = this.dialogService.open(DeleteUserConfirmation, {
          data: data,
          header: 'Confirmation',
          width: '30vw',
          contentStyle: { overflow: 'auto' },
          breakpoints: {
              '960px': '75vw',
              '640px': '90vw'
          }
      });

      this.ref.onClose.subscribe((data: DeleteUserByFirm) => {
          
          if (data) {
            const payload: DeleteUserByFirm = {
              reason : data.reason,
              comments: data.comments,
              firm : this.userService.getUserFirmId(),
            }
            this.userService.deleteUserByFirm(reviewer._id, payload).subscribe((response: any) => {
              this.getReviewers({ first: 0, rows: 10 });
              this.toast.showSuccess('User archived successfully')
            })
          }
          
      });
  }

  async confirmUnarchiveUser(isConfirm = false): Promise<void> {
    if(!isConfirm){
      this.openUnarchiveModal = false;
      this.selectedReviewer = null;
      return;
    }
    await this.userService.restoreUserByFirm(this.selectedReviewer?._id || '');
    this.openUnarchiveModal = false;
    this.selectedReviewer = null;
    this.reloadReviewerTable();

  }

  isReviewerApproveDisable(reviewer: Reviewer) {
    const tenant = this.getCurrentTenant(reviewer);
    return (tenant && tenant.reviewerStatus !== constants.userVerificationStatus.pendingAdminVerification);

  }

  openReviewerDialog(id:string){
    this.reviewerDetailDialogService.openDialog(id);
  }

  favouriteUser($event: Event, reviewer: Reviewer) {
    if(reviewer.isFavourite){
      this.removeAsFavourite(reviewer);
    }else{
      this.setAsFavourite(reviewer);
    }
  }

  removeAsFavourite(reviewer: Reviewer){
    this.peopleService.removeFromFavouriteList(this.userService.getUserFirmId(),reviewer._id).subscribe((resp:any)=>{
      this.toast.showSuccess('Removed to Favorite List');
      reviewer.isFavourite = false;
    })
  }

  setAsFavourite(reviewer: Reviewer){
    const fav = { "favorite": reviewer._id };
    this.peopleService.addToFavouriteList(this.userService.getUserFirmId(),fav).subscribe((resp:any)=>{
      this.toast.showSuccess('added to Favorite List');
      reviewer.isFavourite = true;
    })
  }

  goToProjectDetails(projectId:string){
    this.router.navigateByUrl(`/client/project/started/${projectId}/details`);
  }

  getPendingReviewers() {
    const offset = 0;
    const limit = 10;
    const queryParams: SearchReviewerQueryParams = {
      sortOrder: constants.sortingOrder.descending,
      offset: offset,
      limit: limit,
      searchOn: 'all',
    };
    this.peopleService.getPendingCandidateList(queryParams, this.userService.getUserFirmId()).subscribe((response: SearchReviewerResponse) => {
      this.pendingCandidateButton.label = `PENDING CANDIDATES (${response.count})`;
    })
  }

  onPageChange(event: any): void {
    this.totalRecords = event.first;
  }
}
